import { render, staticRenderFns } from "./SideBySideSettings.vue?vue&type=template&id=754cb1c1"
import script from "./SideBySideSettings.vue?vue&type=script&lang=ts"
export * from "./SideBySideSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('754cb1c1')) {
      api.createRecord('754cb1c1', component.options)
    } else {
      api.reload('754cb1c1', component.options)
    }
    module.hot.accept("./SideBySideSettings.vue?vue&type=template&id=754cb1c1", function () {
      api.rerender('754cb1c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reportengine/SideBySideSettings.vue"
export default component.exports